import React from 'react';
import ContentLayout from '../../components/ContentLayout';
import props from '../../lib/contentLayoutProps/the-kingston-difference/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="">
    <h1>The Kingston Difference</h1>
    <p>
      We are very proud of our students' abilities to use both languages. We provide the perfect environment for native
      fluency in both English and Putonghua. Our small class numbers and high teacher-to-student ratio form the
      cornerstone of our bilingual approach, which is delivered through the IBPYP framework.
    </p>
    <p>
      Kingston International School offers an IB-PYP bilingual (English/Putonghua) programme for students aged 1 to 11
      years of age. Kingston has three campuses - the Kindergarten and Children's Centre which houses our early years
      programme for children 1 to 4 years of age, a Lower Primary campus for students from Year 1 to Year 3 and an Upper
      Primary campus for students from Year 4 to Year 6. Although we have three campuses we are still a small school
      with a community feel. We maintain small class sizes and have an English and a Putonghua class teacher for each
      class.
    </p>
  </ContentLayout>
);
